<template>
  <div class="flex charts-wrapper w-layout-grid grid-2-columns statistics-grid">
    <ClientOnly>
      <DashboardChartAvailability v-if="currentTokenInfo?.isSellable" :formatters="formatters" />

      <DashboardChartLocking
        v-if="currentTokenInfo?.isSellable && store.currentToken === Tokens.pearl"
        :formatters="formatters"
      />

      <DashboardChartDistribution v-if="currentTokenInfo?.isSellable" :formatters="formatters" />

      <DashboardChartSoldBrought v-if="currentTokenInfo?.isSellable" :formatters="formatters" />

      <DashboardChartDex :formatters="formatters" />

      <DashboardChartSeabedRetrieved v-if="currentTokenInfo?.isSellable" :formatters="formatters" />

      <DashboardChartRoi v-if="currentTokenInfo?.isSellable" />

      <DashboardChartBuybackTreasureUsage :formatters="formatters" />

      <DashboardChartHolders :formatters="formatters" />
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
import { Tokens } from '~/utils/constants';

import type { ITokenModel } from '~/types/apiService';
import { Formatters } from '~/utils/formatters/formatters';

const { data: currentTokenInfo } = useNuxtData<ITokenModel>('dashboardCurrentTokenInfo');
const store = useMainStore();

const formatters = {
  label: Formatters.text.createPipeline({
    pipeline: [(value) => Formatters.text.alwaysDefined(value, '').toUpperCase()]
  }),

  tooltip: Formatters.text.createPipeline({
    pipeline: [(value) => Formatters.number.renderString((f) => f.formatNumber(value, 4, 5, true))]
  })
};
</script>

<style scoped lang="scss">
.flex-child {
  overflow: hidden;
  border-radius: 12px;
  background: var(--blue-3);
  border: 1px solid var(--blue-2);
  padding: 33px 33px 53px;
  box-sizing: border-box;

  @media screen and (max-width: 991px) {
    width: 100%;
    padding: 20px;
    font-size: 16px;
    line-height: 1.63em;
  }

  @media screen and (max-width: 767px) {
    padding: 16px 20px;
    font-size: 14px;
  }
}

.charts-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  margin: 20px 0;
}

.w-layout-grid {
  grid-row-gap: 16px;
  grid-column-gap: 16px;
  grid-template-rows: auto auto;
  grid-template-columns: 1fr 1fr;
  grid-auto-columns: 1fr;
  display: grid;
}

.grid-2-columns {
  grid-column-gap: 28px;
  grid-row-gap: 28px;
  grid-template-rows: auto;
  grid-template-columns: 1fr 1fr;
  grid-auto-columns: 1fr;
  align-items: center;
  display: grid;
}

.grid-2-columns.statistics-grid {
  align-items: stretch;
}

@media screen and (max-width: 991px) {
  .grid-2-columns.statistics-grid {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-columns: 1fr 1fr;
  }
}

@media screen and (max-width: 767px) {
  .grid-2-columns {
    grid-template-columns: 1fr;
  }
  .grid-2-columns.statistics-grid {
    flex-direction: column;
    display: flex;
  }
}

.flex-text {
  font-size: 18px;
  font-weight: 400;
  line-height: 1.667em;

  @media screen and (max-width: 991px) {
    font-size: 16px;
  }

  @media screen and (max-width: 767px) {
    font-size: 14px;
  }
}
</style>
